import { Action } from "redux"

import * as actions from "./actions"
import { ITutorial } from "./index"

export const initialState: ITutorial = {
    loaded: false,
}

const handlers: {
    [action: string]: (state: ITutorial, props: Action) => ITutorial
} = {
    [actions.RECEIVE_CONTENT]: (
        state,
        { content }: actions.ReceiveContent,
    ): ITutorial => ({
        ...state,
        content,
        loaded: true,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): ITutorial {
    const handler: (state: ITutorial, action: Action) => ITutorial =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
